function About() {
    return (
        <section id="about" className="section section-soft">
            <div className="container about-grid">
                <div className="about-copy reveal">
                <h2>Por que escolher a Conts Contabilidade?</h2>
                <p>
                    Nosso compromisso é entregar um serviço alinhado às necessidades específicas do seu negócio,
                    com transparência, parceria e alto nível de consultoria.
                </p>

                <div className="ticks">
                    <div className="tick reveal"><span aria-hidden="true">✔</span> Atendimento próximo e consultivo</div>
                    <div className="tick reveal"><span aria-hidden="true">✔</span> Otimização tributária com segurança</div>
                    <div className="tick reveal"><span aria-hidden="true">✔</span> Conformidade fiscal e trabalhista</div>
                    <div className="tick reveal"><span aria-hidden="true">✔</span> Apoio para decisões estratégicas</div>
                </div>
                </div>

                <div className="about-panel reveal">
                <h3>Como trabalhamos</h3>
                <ol className="steps">
                    <li><strong>Diagnóstico</strong><span>Entendemos seu contexto e prioridades.</span></li>
                    <li><strong>Plano de ação</strong><span>Definimos rotinas, prazos e oportunidades.</span></li>
                    <li><strong>Execução</strong><span>Operação com controles e comunicação clara.</span></li>
                    <li><strong>Melhoria contínua</strong><span>Ajustes para manter performance e compliance.</span></li>
                </ol>
                </div>
            </div>
        </section>
    );
}

export default About;